export const standardFeatures = [
    "Ongoing project development coordination and support",
    "Extended monitoring and reporting by User Role",
    "New project recommendations and procurement guidance",
    "Enhanced financial guidance and incentive navigation",
    "Enhanced regulatory compliance reporting",
    "Revenue recommendations and optimization",
  ];
  
  export const premiumFeatures = [
    "AI-Enabled Energy Project Roadmap",
    "Energy Asset Revenue Management",
    "Voice of ZEOS",
    "Talk to My Building",
  ];